import React from 'react';
import { useState, useRef } from 'react';
import RecipeIngredientForm from './RecipeIngredientForm/RecipeIngredientForm';
import "./RecipeForm.css"
import RecipeInstructions from '../RecipeInstructions/RecipeInstructions';
import { useData } from "../../DataContext/DataProvider"

/**
 * Form for submitting new recipes
 * @param handleSubmit sumbit button handler, code in RecipePage.js 
 * @returns form element
 */

function RecipeForm({ inputRecipe, setInputRecipe}) {

    const isVisible = (inputRecipe.Recipe_ID !== -2)
    const [showInstructions, setShowInstructions] = useState(false)
    const dataContext = useData();

    const mappedRecipeInstructions = inputRecipe.Recipe_Instructions.map((element, index) => {
        return ({
            ...element,
            index: index
        })
    })
    
    const newRef = useRef(null);

    function handleAddNewRecipe() {
        setInputRecipe({
            Recipe_ID: -1,//
            Recipe_Name: "",
            Recipe_Time: null,
            Recipe_Difficulty: null,
            Recipe_Ingredients: [],
            Recipe_Instructions: []
        })
    }

    function cancelHandler(e) {
        e.preventDefault();
                
        setInputRecipe({
            ...inputRecipe,
            Recipe_ID: -2
        })
    }
    function handleRecipeSubmit(e) {
        if (newRef.current.reportValidity()) {
            dataContext.recipesData.submitRecipe(inputRecipe)
            setInputRecipe({
                ...inputRecipe,
                Recipe_ID: -2//-2 is the flag for hide the recipe form
            })
        }
    }

    function loseFocusHandler(e) {
        const { name, value } = e.target;
        const newRecipeData = {
            ...inputRecipe,
            [name]: value.trim()
        }

        setInputRecipe(newRecipeData)
    }
    
    /**Change handlers:*/
    function addIngredient(e) {
        e.preventDefault();
        
        const newRecipeData = {
            ...inputRecipe,
            Recipe_Ingredients: [
                ...inputRecipe.Recipe_Ingredients,
                {
                    Ingredient_Name: "",
                    Ingredient_Quantity: 0
                }
            ]
        };
        
        setInputRecipe(newRecipeData);
    }

    function changeHandler(e) {
        
        const { name, value } = e.target;
        const newRecipeData = {
            ...inputRecipe,
            [name]: value
        }
        
        setInputRecipe(newRecipeData)
    }

    function changeInstructionsHandler(e) {
        var newInstructionsArray = [...e]

        const newRecipeData = {
            ...inputRecipe,
            Recipe_Instructions: newInstructionsArray
        };

        setInputRecipe(newRecipeData)
    }

    function changeIngredientHandler(name, value, idNum) {
        var newArray = [...inputRecipe.Recipe_Ingredients];

        newArray[idNum] = {
            ...newArray[idNum],
            [name]: value,
            changed: newArray[idNum].Recipe_Ingredient_ID ? true : null//changed should only be flagged if the entity already has a database ID number
        }

        const newRecipeData = {
            ...inputRecipe,
            Recipe_Ingredients: newArray
        }

        setInputRecipe(newRecipeData)
    }

    function removeIngredient(e) {
        e.preventDefault();
        
        const idString = e.target.id;
        const idNum = idString.slice(18, idString.length);//18 is the length of Remove_Ingredient_

        var newArray = inputRecipe.Recipe_Ingredients.slice();
        newArray.splice(idNum, 1);

        const newRecipeData = {
            ...inputRecipe,
            Recipe_Ingredients: newArray
        };

        setInputRecipe(newRecipeData)

        newRef.current.reset();
    }

    function showInstructionsHandler(e) {
        e.preventDefault();
        setShowInstructions(!showInstructions)
    }


    return (
        <div className={"recipe-form-switcher " + (isVisible ? "form-visible" : "form-hidden")}>
            <div className="add-button-container container recipe-element hoverable-element" style={{ whiteSpace: 'pre-wrap'}} >
                <button id="add_recipe" className="button" onClick={handleAddNewRecipe }>New Recipe</button>
            </div>
            <div className="recipe-form-container visible-element container" style={{ whiteSpace: 'pre-wrap'}} >
                <form id="Recipe_Form" ref={newRef}>
                    <div className="form-container">
                        <label className="form-element recipe  hoverable-element" >Recipe Name:
                            <input type="text"
                                id="Recipe_Name"
                                name="Recipe_Name"
                                placeholder="Recipe Name..."
                                onChange={changeHandler}
                                onBlur={loseFocusHandler }
                                value={inputRecipe.Recipe_Name}
                                pattern="(?!.*[;]).*"
                                maxLength="70"
                                required
                            />
                        </label>
                        <label className="form-element recipe  hoverable-element">Recipe Time:
                            <input type="number"
                                id="Recipe_Time"
                                name="Recipe_Time"
                                placeholder="...minutes"
                                onChange={changeHandler}
                                min="0"
                                max="2147483647"
                                value={inputRecipe.Recipe_Time ?? ""}
                                onFocus={e => e.target.select()}
                                required
                            />
                        </label>
                        <label className="form-element recipe  hoverable-element">Recipe Difficulty:
                            <input type="number"
                                id="Recipe_Difficulty"
                                name="Recipe_Difficulty"
                                placeholder=".../10"
                                onChange={changeHandler}
                                min="0"
                                value={inputRecipe.Recipe_Difficulty ?? ""}
                                max="10"
                                onFocus={e => e.target.select()}
                                required
                            />
                        </label>
                        <label className="form-element recipe hoverable-element">Recipe Ingredients:
                            <ul>
                                {
                                    inputRecipe.Recipe_Ingredients.map((ingredient, idNum) => (
                                        <RecipeIngredientForm key={idNum} idNum={idNum} ingredient={ingredient} removeIngredient={removeIngredient} changeHandler={changeIngredientHandler} />
                                    ))
                                }
                            </ul>
                            <button className="add-ingredient-button button" type="button" onClick={addIngredient} > Add </button>
                        </label>
                        <div className="column">
                            <button className="show-instructions button" onClick={showInstructionsHandler} > {showInstructions ? "Hide Recipe Instructions" : "See Recipe Instructions"} </button>
                            <RecipeInstructions inputInstructions={mappedRecipeInstructions} changeHandler={changeInstructionsHandler} showInstructions={showInstructions}/>
                        </div>
                        <div className="form-element button-container recipe hoverable-element">
                            <input type="button" className="button submit recipe button" value="Submit" onClick={handleRecipeSubmit} />
                            <input type="button" className="button cancel recipe button" value="Cancel" onClick={cancelHandler} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
        
    );
}


export default RecipeForm